import "./styles.sass";

import React, { FC, useEffect, useState } from "react";
import ShowMoreIcon from "../../../assets/icons/ShowMoreIcon";

interface ICustomSelect {
  list: any[];
  label?: string;
  selected?: string;
  defaultValue: string;
  onChange: (item: IListItem) => void;
  disabled?: boolean;
}

export interface IListItem {
  value: string;
  label: string;
  default?: boolean;
}

const CustomSelect: FC<ICustomSelect> = ({
  list,
  label,
  onChange,
  selected,
  defaultValue,
  disabled = false,
}) => {
  const [selectedItem, setSelectedItem] = useState<IListItem>({} as IListItem);
  const [show, setShow] = useState(false);

  useEffect(() => {
    selected ? setOption(selected) : setOption(defaultValue);
  }, []);

  function getItemFromList(item: string) {
    return list.find((option) => option.value === item);
  }

  function isSelected(value: string) {
    return value === selected || value === defaultValue;
  }

  function getDefault() {
    return list.find((item) => item.default === true);
  }

  function setOption(option: string) {
    setSelectedItem(getItemFromList(option));
    onChange(getItemFromList(option));
  }

  function getSelectedLabel() {
    return selectedItem ? selectedItem.label : getDefault().label;
  }

  function onSelect(option: IListItem) {
    setSelectedItem(option);
    setShow(false);
    onChange(option);
  }

  return (
    <div className={`custom-select ${disabled ? "disabled" : ""}`}>
      <div className="label">{label}</div>
      <div className="select">
        <div
          className={`select-container ${show ? "open" : ""}`}
          onClick={() => setShow(!show)}
        >
          <div className="selected-value">{getSelectedLabel()}</div>
          <span className="icon">
            <ShowMoreIcon color={"red"} />
          </span>
        </div>
        <ul className={`option-list ${show ? "open" : ""}`}>
          {list.map((option) => (
            <li
              className={`option-item ${
                isSelected(option.value) ? "selected" : ""
              }`}
              onClick={() => onSelect(option)}
              key={`${option.label}-${option.value}`}
            >
              {option.label}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CustomSelect;
